import { VaxEntry } from '../model/mobilfunk';
import { NocoDbList, NocoDbPageInfo } from '../model/noco-db';
import { DataFetcher, DataFetcherMethod } from './fetcher/DataFetcher';
import { RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

const efilter = {
	sort: 'relevanz',
	sex: null,
	hospitalized: null,
	vaccination: [],
	manufacturer: [],
	vax_damage: [],
	health_result: [],
	age: [],
	zip: null,
	batch_number: null,
	country: [],
	filter_language: [],
	damage_occurred: [],
	admin_date: {
		start: null,
		end: null,
		unknown_day: false,
		unknown_month: false,
		unknown_date: false,
		include_unknown: false,
	},
	search: undefined,
	pre_health_damage: [],
};
export interface VaxSearchParams {
	//TODO
	_term?: string;
	title?: string;
	tags?: string;
	report_from?: string;
	date?: string;
	license?: string;
	country?: string;
	page?: number;
}

export class VaxRepository extends RepositoryNocoDbBase<
	VaxEntry,
	VaxSearchParams
> {
	// protected readonly API_ROUTE = `${process.env.NOCO_DB_API_URL}/tables/${process.env.NOCO_DB_MOBILFUNK_TABLE_ID}/records`;
	protected readonly API_ROUTE = `${process.env.API_URL}v1/vax`;
	protected readonly META_ROUTE = ``;

	public constructor(_fetcher: DataFetcher) {
		super(_fetcher);
	}

	async getPageInfo({ ...fetchProps }: NocoDbPageInfo) {
		return (await this.search({ search: { page: 1 } })).pageInfo;
	}

	async getEntryCount({ ...fetchProps }) {
		return (
			await this._fetcher.execute<NocoDbList<Report>>({
				method: DataFetcherMethod.Post,
				url: this.API_ROUTE + '/get_entries_count',
				body: JSON.stringify(efilter),
				headers: await this.authHeaders(),
				...fetchProps,
			})
		).data;
	}

	protected composeSearchRoute(search?: VaxSearchParams) {
		//TODO
		const where: string[] = [];

		// Command creators
		// TODO: find better location to provide this functions
		// const createLikeCommand = (fieldName: string, value: string) =>
		// 	`(${fieldName},like,${value})`;
		// const createExtactDateCommand = (fieldName: string, value: string) =>
		// 	`(${fieldName},eq,exactDate,${value})`;

		// for (const [key, value] of Object.entries(search ?? {}) as Entries<typeof search>) {
		//     if (!value) continue; // Skip for empty values
		//
		//     switch (key) {
		//         case "_term":
		//             // search with `_term` in multiple fields
		//             ["title", "tags", "report_from"].map(field => where.push(createLikeCommand(field, value)));
		//             break;
		//         case "date":
		//             where.push(createExtactDateCommand(key, value));
		//             break;
		//         default:
		//             // For other fields, search in the exact same field name
		//             where.push(createLikeCommand(key, value));
		//             break;
		//     }
		// }

		// TODO: Implemente better (like `where`  condition) by appling sort dropdown
		const sortCommand = 'sort=-CreatedAt';

		// Combine route with search params
		// Example: https://noco.elaion.ch/api/v2/tables/mtvs0nudqrspnlj/records?where=%28title%2Clike%2Cserbien%29%7Eor%28tags%2Clike%2Cserbien%29%7Eor%28report_from%2Clike%2Cserbien%29
		// API Documentation:
		// - https://noco.elaion.ch/api/v2/meta/bases/ppliqomdhpa476f/swagger
		// - https://data-apis-v2.nocodb.com/#tag/Table-Records/operation/db-data-table-row-list
		// - https://docs.nocodb.com/0.109.7/developer-resources/rest-apis/#query-params
		// if (where.length > 0) {
		// 	const searchParam = new URLSearchParams({ where: where.join('~or') });
		// 	return `${this.API_ROUTE}?${searchParam}&${sortCommand}`;
		// }
		// console.log(`${this.API_ROUTE}?page=${search?.page}`)
		return `${this.API_ROUTE}?page=${search?.page}`;

		// As default return route without `where` param
		return `${this.API_ROUTE}?${sortCommand}`;
	}
}
